import useRedirect from "@/hooks/useRedirect";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { REGISTRATION_PAGE } from "@/settings/constant";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import { deleteReview, putReviewsLike } from "src/api/review";
const useReviewHandler = (productItem)=>{
    const queryClient = useQueryClient();
    const { loginPath  } = useRedirect();
    const router = useRouter();
    const putReviewHelpCountMutation = useMutation(putReviewsLike);
    const deleteReviewMutation = useMutation(deleteReview);
    const [reviewStatus, setReviewStatus] = useState(null);
    const [deleteReviewId, setDeleteReviewId] = useState(null);
    // 좋아요 낙관적 업데이트 실패한 곳
    const { mutate: putReviewMutate  } = useMutation({
        mutationFn: putReviewsLike,
        onMutate: async (param)=>{
            ;
            await queryClient.cancelQueries({
                queryKey: [
                    "getReviews"
                ]
            });
            const previousData = queryClient.getQueryData([
                "getReviews"
            ]);
            ;
            queryClient.setQueryData([
                "getReviews"
            ], (old)=>{
                if (!old) return;
                ;
                const newReviews = old.pages.map((page)=>{
                    return {
                        ...page,
                        data: page.data.map((review)=>{
                            if (review.id === param.id) {
                                return {
                                    ...review,
                                    likeInfo: {
                                        ...review.likeInfo,
                                        count: param.status === "on" ? review.likeInfo.count + 1 : review.likeInfo.count - 1,
                                        isOn: param.status === "on"
                                    }
                                };
                            }
                            return review;
                        })
                    };
                });
                ;
                return {
                    pages: newReviews,
                    pageParams: old.pageParams
                };
            });
            return {
                previousData
            };
        },
        onError: (error, variables, context)=>{
            ;
        },
        onSettled: (data, error, variables, context)=>{
            ;
            queryClient.invalidateQueries([
                "getReviews"
            ]);
        }
    });
    const handleReviewHelpCountClick = useCallback(async (param)=>{
        try {
            await putReviewHelpCountMutation.mutateAsync(param);
            queryClient.invalidateQueries([
                "getReviews"
            ]);
            mixpanelEvent("Review Thanks Completed", {
                //mx-111 채워야 할 항목은 배포전에 확인해야할듯 합니다.
                "후기 ID": param.id,
                "Product ID": productItem.id,
                "Product Title": productItem.title,
                "Product Subject": productItem.sub_category,
                Author: productItem.author,
                "Based Source Product ID": productItem.source.product_id,
                "Based Source Product Title": productItem.source.title
            });
        } catch (error) {
            const { status  } = error.response;
            if (status === 401) {
                setReviewStatus({
                    type: "login"
                });
            }
        }
    }, [
        putReviewHelpCountMutation,
        queryClient,
        setReviewStatus
    ]);
    const deleteReviewSuccess = useCallback(async (id)=>{
        try {
            setReviewStatus(()=>({
                    type: "success"
                }));
            await deleteReviewMutation.mutateAsync({
                id
            });
            queryClient.invalidateQueries([]);
            mixpanelEvent("Review Delete Completed", {
                //mx-115
                "후기 ID": id,
                "Product ID": productItem.id,
                "Product Title": productItem.title,
                "Product Subject": productItem.sub_category,
                Author: productItem.author,
                "Based Source Product ID": productItem.source.product_id,
                "Based Source Product Title": productItem.source.title
            });
        } catch (error) {
            const { status  } = error.response;
            setReviewStatus({
                type: "error",
                errorCode: status
            });
        }
    }, [
        deleteReviewMutation,
        setReviewStatus
    ]);
    const handleDeleteReview = useCallback((id)=>{
        setReviewStatus({
            type: "delete"
        });
    }, [
        setReviewStatus
    ]);
    const handleModalClose = useCallback(()=>{
        setReviewStatus(null);
    }, [
        setReviewStatus
    ]);
    const setModalProps = useCallback(()=>{
        switch(reviewStatus.type){
            case "login":
                return {
                    isOpen: true,
                    onClose: ()=>handleModalClose(),
                    title: "로그인이 필요해요",
                    content: "로그인 혹은 회원가입을 진행해 주세요.",
                    prefix: {
                        label: "로그인",
                        variant: "soft",
                        handleClick: ()=>{
                            handleModalClose(), router.push(loginPath);
                        }
                    },
                    suffix: {
                        label: "회원가입",
                        variant: "solid",
                        handleClick: ()=>{
                            handleModalClose(), router.push(REGISTRATION_PAGE);
                        }
                    }
                };
            case "success":
                return {
                    isOpen: true,
                    onClose: ()=>handleModalClose(),
                    title: "후기가 삭제되었어요.",
                    suffix: {
                        label: "확인",
                        variant: "solid",
                        handleClick: ()=>{
                            // queryClient.invalidateQueries(['getReviews'])
                            handleModalClose();
                        }
                    }
                };
            case "delete":
                return {
                    isOpen: true,
                    onClose: ()=>handleModalClose(),
                    severity: "caution",
                    title: "후기를 삭제하시겠어요?",
                    content: "삭제된 후기는 복구가 불가능하며, 해당 자료의 후기를 다시 작성하실 수 없습니다.",
                    prefix: {
                        label: "취소",
                        variant: "soft",
                        handleClick: ()=>{
                            mixpanelEvent("Popup Button Clicked", {
                                //mx-113
                                "Popup Type": "Check Deleting Review",
                                "Popup Title": "후기를 삭제하시겠어요?",
                                "Button Name": "취소",
                                "Button URL": "null"
                            });
                            handleModalClose();
                        }
                    },
                    suffix: {
                        label: "삭제하기",
                        variant: "solid",
                        handleClick: ()=>{
                            deleteReviewSuccess(deleteReviewId);
                            // setReviewStatus(null)
                            mixpanelEvent("Popup Button Clicked", {
                                //mx-114
                                "Popup Type": "Check Deleting Review",
                                "Popup Title": "후기를 삭제하시겠어요?",
                                "Button Name": "삭제하기",
                                "Button URL": "null"
                            });
                        }
                    }
                };
            case "error":
                const contents = {
                    title: reviewStatus.errorCode === 403 ? "본인 후기가 아닙니다." : "후기 삭제에 실패했어요.",
                    content: reviewStatus.errorCode === 403 ? "본인 후기만 삭제할 수 있어요." : "다시 시도해 주세요."
                };
                return {
                    isOpen: true,
                    onClose: ()=>handleModalClose(),
                    title: contents.title,
                    content: contents.content,
                    suffix: {
                        label: "확인",
                        variant: "solid",
                        handleClick: ()=>{
                            handleModalClose();
                        }
                    }
                };
            default:
                return {
                    isOpen: true,
                    onClose: ()=>handleModalClose(),
                    title: "다시 시도해주세요.",
                    suffix: {
                        label: "확인",
                        variant: "solid",
                        handleClick: ()=>{
                            handleModalClose();
                        }
                    }
                };
        }
    }, [
        reviewStatus,
        handleModalClose,
        deleteReviewSuccess
    ]);
    return [
        handleReviewHelpCountClick,
        handleDeleteReview,
        deleteReviewSuccess,
        reviewStatus,
        setReviewStatus,
        setModalProps,
        setDeleteReviewId
    ];
};
export default useReviewHandler;
